import { AxiosError } from 'axios';

import { GetZeePersonaDataApiResponse } from '@/actions/zee-persona-data/getZeePersonaData';
import { ZEE_PERSONA_DATA_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';
import { UpdateZeePersonaDataPayload } from '@/types/zee-persona-data.type';

export const updateZeePersonaData = async (
  userId: string,
  payload: UpdateZeePersonaDataPayload
): Promise<ApiResponse<GetZeePersonaDataApiResponse>> => {
  try {
    const response = await apiManager.put(
      `${ZEE_PERSONA_DATA_API_URL}/${userId}`,
      payload,
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
